import { render, staticRenderFns } from "./ReplacementCandidateFile.html?vue&type=template&id=91ff03dc&external"
import script from "./ReplacementCandidateFile.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementCandidateFile.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementCandidateFile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports